import type { OrgId } from "@/domain/ids";

export const TEMPLATE_NAMES = [
  "invite",
  "password_reset",
  "trial_ending",
  "trial_expired",
  "payment_failed",
  "subscription_cancelled",
  "suspended",
  "subscription_receipt",
] as const;

export type TemplateName = typeof TEMPLATE_NAMES[number];

export function isTemplateName(value: string): value is TemplateName {
  return (TEMPLATE_NAMES as readonly string[]).includes(value);
}

export type EmailSendStatus =
  | "sent"
  | "failed"
  | "rate_limited"
  | "dropped_allowlist";

export type EmailProvider = "mock" | "resend";

export interface SendEmailInput {
  readonly to: string;
  readonly subject: string;
  readonly html: string;
  readonly text: string;
  readonly template: TemplateName;
  readonly orgId?: OrgId | null;
}

export type SendFailureCode =
  | "RATE_LIMITED"
  | "ALLOWLIST_DROP"
  | "PROVIDER_ERROR";

export type SendResult =
  | { readonly success: true; readonly messageId: string | null }
  | { readonly success: false; readonly code: SendFailureCode; readonly message: string };

export interface CapturedEmail {
  readonly to: string;
  readonly subject: string;
  readonly html: string;
  readonly text: string;
  readonly template: TemplateName;
  readonly status: EmailSendStatus;
  readonly sentAt: string;
}

export interface ProviderAdapter {
  readonly name: EmailProvider;
  send(input: SendEmailInput): Promise<{ readonly messageId: string | null }>;
}

export interface EmailService {
  send(input: SendEmailInput): Promise<SendResult>;
}
